/**
 * Test-Sektion-Model
 * @class service_v3sTestSection
 * @memberOf v3sWbtPlayerApp:model
 * @extends v3sWbtPlayerApp:model.service_v3sSection
 */

angular.module('v3sWbtPlayerApp').factory('v3sTestSection', ["v3sTestItem", "v3sSection", "v3sArrayService", "v3sPots", function (v3sTestItem, v3sSection, v3sArrayService, v3sPots) {

    // instantiate the sco object
    var v3sTestSection = function (data, options) {

        this.children = [];
        this.sectionCatalog = [];
        this.exerciseCatalog = [];
        this.maxExercises = 0;
        this.selected = true;
        this.maxSections = 3;

        this.scoreData = {
            evaluated: 0,
            passed: 0
        };

        this.selectedExercises = [];
        this.allSelectedExercises = [];

        // use the original item object constructor
        v3sSection.apply(this, arguments);

        this.childrenIncludeFilter = [this.ScormDataEnum.STATUS, this.ScormDataEnum.SCORE];

        var questions;
        if (!!this.parameters.questions) {
            questions = this.parameters.questions;
        } else if (!!options && !!options.questions) {
            questions = options.questions;
        } else {
            questions = "100%";
        }

        this.order = "random";
        if(!!this.parameters.order) {
            this.order = this.parameters.order;
        } else if (!!options && options.order) {
            this.order = options.order;
        }

        if (!!data && this.type === "section") {
            for (var i = 0; i < data.children.length; i++) {
                var newItem = null;
                var item = data.children[i];

                if (item.type === "section") {
                    newItem = this.createTestSection(item, { questions: questions, order: this.order });
                    this.sectionCatalog.push(newItem);

                } else {
                    newItem = this.createTestItem(item, {});
                    this.exerciseCatalog.push(newItem);
                }
                newItem.parent = this;
                this.children[i] = newItem;
            }
        }

        this.masteryscore = !!this.parameters.passedAt ? parseInt(this.parameters.passedAt) : 0;

        this.setMaxExercises(questions);
    };

    // use the original v3sSco prototype
    v3sTestSection.prototype = new v3sSection();

    v3sTestSection.prototype.getExerciseStatistic = function () {
        var statisticData = { count: 0, correct: 0, wrong: 0, score: 0 };
        return statisticData;
    };

    /**
    * Erstellt eine Test-Subsektion
    * @memberOf v3sWbtPlayerApp:model.service_v3sTestSection
    */
    v3sTestSection.prototype.createTestSection = function (data, options) {
        return new v3sTestSection(data, options);
    };

    /**
    * Erstellt eine Aufgaben-Seite
    * @memberOf v3sWbtPlayerApp:model.service_v3sTestSection
    */
    v3sTestSection.prototype.createTestItem = function (data, options) {
        return new v3sTestItem(data, options);
    };

    /**
        * Legt die Anzahl der zu ziehenden Fragen aus der Sektion fest
        * @memberOf v3sWbtPlayerApp:model.service_v3sTestSection
        * @param {string|number} maxQestions - maximale Anzahl der Fragen (feste Zahl oder Prozent)
        */
    v3sTestSection.prototype.setMaxExercises = function (maxQestions) {
        this.maxExercises = this.exerciseCatalog.length;

        if (typeof maxQestions !== "undefined") {
            if (maxQestions >= 0) {
                this.maxExercises = parseFloat(maxQestions);
            }else if (maxQestions.indexOf("%") != -1) {
                var maxQuestionsPercent = parseFloat(maxQestions);
                if (maxQuestionsPercent > 0 && maxQuestionsPercent <= 100) {
                    this.maxExercises = Math.ceil(maxQuestionsPercent * this.exerciseCatalog.length / 100);
                }
            } else {
                var maxQuestionsValue = parseInt(maxQestions);
                if (maxQuestionsValue >= 1) {
                    this.maxExercises = Math.ceil(maxQuestionsValue);
                }
            }
        }

        if (!this.getTestConfig("allExercisesInOneSection") && this.maxExercises > this.exerciseCatalog.length) {
            this.maxExercises = this.exerciseCatalog.length;
        }
    };

    /**
    * Gibt die Anzahl der zu ziehenden Fragen aus der Sektion zurück
    * @memberOf v3sWbtPlayerApp:model.service_v3sTestSection
    */
    v3sTestSection.prototype.getMaxExercises = function () {
        var exercises = 0;

        if (this.isSelected()) {
            exercises = this.maxExercises;
        }

        return exercises;
    };

    v3sTestSection.prototype.getMaxSections = function () {
        return this.maxSections;
    }

    /**
    * Gibt die Anzahl der zu ziehenden Fragen aus allen Sektionen zurück
    * @memberOf v3sWbtPlayerApp:model.service_v3sTestSection
    */
    v3sTestSection.prototype.getAllMaxExercises = function () {
        var exercises = this.getMaxExercises();

        if (!this.getTestConfig("allExercisesInOneSection")) {
            for (var j = 0; j < this.sectionCatalog.length; j++) {
                exercises += this.sectionCatalog[j].getAllMaxExercises();
            }
        }

        return exercises;
    };

    /**
    * Gibt Test zurück.
    * @memberOf v3sWbtPlayerApp:model.service_v3sTestSection
    */
    v3sTestSection.prototype.getTest = function () {
        var test = null;
        if (!!this.parent) {
            test = this.parent.getTest();
        }
        return test;
    };

    /**
    * Gibt die Einstellung des Test-Configs zurück.
    * @memberOf v3sWbtPlayerApp:model.service_v3sTestSection
    */
    v3sTestSection.prototype.getTestConfig = function (key) {
        var value = null;

        var test = this.getTest();
        if (!!test) {
            var config = test.getConfig();
            if (!!config && config.hasOwnProperty(key)) {
                value = config[key];
            }
        }

        return value;
    };

    /**
    * Selektiert die Sektion für die Fragenziehung
    * @memberOf v3sWbtPlayerApp:model.service_v3sTestSection
    */
    v3sTestSection.prototype.select = function (selected) {
        this.selected = selected !== false;
    };

    /**
    * Selektiert die Sektion und alle Kinder-Sektionen für die Fragenziehung
    * @memberOf v3sWbtPlayerApp:model.service_v3sTestSection
    */
    v3sTestSection.prototype.selectAll = function (selected) {
        this.selected = selected !== false;
        for (var j = 0; j < this.sectionCatalog.length; j++) {
            this.sectionCatalog[j].selectAll(selected);
        }
    };

    /**
    * Gibt zurück, ob die Sektion für die Fragenziehung selektiert ist
    * @memberOf v3sWbtPlayerApp:model.service_v3sTestSection
    */
    v3sTestSection.prototype.isSelected = function () {
        return this.selected;
    };

    /**
    * Setzt die Sektion und allen darin beinhalteten Fragen zurück
    * @memberOf v3sWbtPlayerApp:model.service_v3sTestSection
    */
    v3sTestSection.prototype.reset = function () {
        this.selectedExercises = [];
        this.allSelectedExercises = [];

        this.scoreData.evaluated = 0;
        this.scoreData.passed = 0;

        this.status = "incomplete";
        this.score = 0;

        for (var i = 0; i < this.exerciseCatalog.length; i++) {
            this.exerciseCatalog[i].reset();
        }

        for (var j = 0; j < this.sectionCatalog.length; j++) {
            this.sectionCatalog[j].reset();
        }
    };

    function concatAllExercises(testsection) {
        var exercises = [];
        //Gibt es Kinderelement?
        var sectionsCatalog = testsection.getSectionsCatalog();
        for (var i = 0; i < sectionsCatalog.length; i++) {
            if (sectionsCatalog[i].locked)
                continue;
            exercises = exercises.concat(concatAllExercises(sectionsCatalog[i]));
        }
        return exercises.concat(testsection.exerciseCatalog);
    }

    /**
    * Die Fragen werden für den Test zufällig ausgewählt
    * @memberOf v3sWbtPlayerApp:model.service_v3sTestSection
    */
    v3sTestSection.prototype.selectExercises = function () {
        var pots = this.getTestConfig("pots") || v3sPots.NONE;

        if (this.isSelected()) {
            var exercises = [];
            var selectedExercises;

            if (!!this.getTestConfig("allExercisesInOneSection")) {
                selectedExercises = this.allSelectedExercises;

                //Wenn es einen

                for (var j = 0; j < this.sectionCatalog.length; j++) {
                    //exercises = exercises.concat(this.sectionCatalog[j].exerciseCatalog);
                    exercises = exercises.concat(concatAllExercises(this.sectionCatalog[j]));
                }
                exercises = exercises.concat(this.exerciseCatalog);
                exercises = v3sArrayService.shuffle(exercises, false, this.order);
            } else {
                selectedExercises = this.selectedExercises;
                exercises = v3sArrayService.shuffle(this.exerciseCatalog, true, this.order);
            }

            var maxExercises = this.getMaxExercises();

            for (var j = 0; j < pots.length; j++) {
                var potMaxExercises = maxExercises;
                if (!!pots[j].maxPercent) {
                    potMaxExercises = maxExercises * pots[j].maxPercent;
                }

                var selectedPotExercises = 0;
                for (var i = 0; i < exercises.length && (selectedExercises.length < maxExercises && selectedPotExercises < potMaxExercises) ; i++) {
                    if (!exercises[i].isSelected() && exercises[i].hasStatistic(pots[j].statistic)) {
                        exercises[i].select();
                        selectedPotExercises++;
                    }
                }
            }
        }

        if (!this.getTestConfig("allExercisesInOneSection")) {
            var sections = this.sectionCatalog;
            for (var j = 0; j < sections.length; j++) {
                sections[j].selectExercises();
            }
        }
    };

    /**
    * Die Fragen werden zu den ausgewählten Fragen hinzugefügt
    * @memberOf v3sWbtPlayerApp:model.service_v3sTestSection
    */
    v3sTestSection.prototype.addToSelectedExercises = function (exercise) {
        this.selectedExercises.push(exercise);
        this.addToAllSelectedExercises(exercise);
    };

    /**
    * Die Fragen werden zu den ausgewählten Fragen aller Sub-Sektionen hinzugefügt
    * @memberOf v3sWbtPlayerApp:model.service_v3sTestSection
    */
    v3sTestSection.prototype.addToAllSelectedExercises = function (exercise) {
        this.allSelectedExercises.push(exercise);

        if (!!this.parent && !!this.parent.addToAllSelectedExercises) {
            this.parent.addToAllSelectedExercises(exercise);
        }
    };

    /**
    * Gibt die Listen der gezogenen Fragen nur aus der Sektion zurück (ohne Kinder-Sektionen)
    * @memberOf v3sWbtPlayerApp:model.service_v3sTestSection
    */
    v3sTestSection.prototype.getSelectedExercises = function () {
        return this.selectedExercises;
    };

    /**
    * Gibt die Listen der gezogenen Fragen zurück (in der Sektion und in allen Kinder-Sektionen)
    * @memberOf v3sWbtPlayerApp:model.service_v3sTestSection
    */
    v3sTestSection.prototype.getAllSelectedExercises = function () {
        return this.allSelectedExercises;
    };

    /**
    * Gibt die Score-Daten zurück
    * @memberOf v3sWbtPlayerApp:model.service_v3sTestSection
    */
    v3sTestSection.prototype.getScoreData = function (performScoreCalculation) {
        var scoreData = {};

        if (!!this.masteryscore && performScoreCalculation) { //Falls Masteryscore definiert ist, dann soll Eltern-Sektion diese Sektion als eine Aufgabe betrachten
            scoreData.evaluated = this.scoreData.evaluated ? 1 : 0;
            scoreData.passed = this.score >= this.masteryscore ? 1 : 0;
        } else {
            scoreData = this.scoreData;
        }

        return scoreData;
    };

    /**
    * Gibt die Fragen-Statistik für die Sektion zurück
    * @memberOf v3sWbtPlayerApp:model.service_v3sTestSection
    */
    v3sTestSection.prototype.getExerciseStatistic = function (pots) {
        pots = pots || {
            exercises: { count: 0 },
            evaluated: { count: 0 },
            evaluationTries: { count: 0 },
            sometimePassed: { count: 0, regexp: /1/ },
            lastPassed: { count: 0, regexp: /1$/ },
            sometimeFailed: { count: 0, regexp: /0/ },
            lastFailed: { count: 0, regexp: /0$/ }
        };

        for (var i = 0; i < this.exerciseCatalog.length; i++) {
            this.exerciseCatalog[i].getStatistic(pots);
        }

        return pots;
    };

    /**
    * Gibt die gesamte Fragen-Statistik zurück (in der Sektion und in allen Kinder-Sektionen)
    * @memberOf v3sWbtPlayerApp:model.service_v3sTestSection
    */
    v3sTestSection.prototype.getAllExerciseStatistic = function (pots) {
        var pots = this.getExerciseStatistic(pots);
        for (var i = 0; i < this.sectionCatalog.length; i++) {
            this.sectionCatalog[i].getAllExerciseStatistic(pots);
        }
        return pots;
    };

    /**
    * Score-Berechnung
    * @memberOf v3sWbtPlayerApp:model.service_v3sTestSection
    */
    v3sTestSection.prototype.update = function () {
        var evaluateAllSelected = this.getTestConfig("evaluateAllSelected");

        this.scoreData.evaluated = 0;
        this.scoreData.passed = 0;

        for (var i = 0; i < this.selectedExercises.length; i++) {
            if (evaluateAllSelected || this.selectedExercises[i].isEvaluated()) {
                this.scoreData.evaluated++;
                if (this.selectedExercises[i].isPassed()) {
                    this.scoreData.passed++;
                }
            }
        }

        for (var i = 0; i < this.sectionCatalog.length; i++) {
            var sectionScoreData = this.sectionCatalog[i].getScoreData(true);
            this.scoreData.evaluated += sectionScoreData.evaluated;
            this.scoreData.passed += sectionScoreData.passed;
        }

        var score = 0;
        if (this.scoreData.evaluated > 0) {
            score = this.scoreData.passed / this.scoreData.evaluated * 100;
        }

        this.score = score;

        //Das TestSCO nur updaten, wenn alle Testsections ausgewertet sind...
        //Sorry Sergius...
        if (!this.parent.sco) {
            this.parent.update();
        }
    };
    v3sTestSection.prototype.updateExercisesCount = function () { };

    /**
    * Schließt die Sektion nach einem Test ab (Status und Score werden neu berechnet)
    * @memberOf v3sWbtPlayerApp:model.service_v3sTestSection
    */
    v3sTestSection.prototype.complete = function () {
        this.status = "completed";

        for (var i = 0; i < this.selectedExercises.length; i++) {
            this.selectedExercises[i].complete();
        }

        for (var i = 0; i < this.sectionCatalog.length; i++) {
            this.sectionCatalog[i].complete();
        }
    };

    /**
    * Gibt den Aufgaben-Status zurück
    * @memberOf v3sWbtPlayerApp:model.service_v3sTestSection
    */
    v3sTestSection.prototype.getExerciseStatus = function () {
        var status = "";

        if (this.selected) {
            if (this.score >= this.masteryscore) {
                status = "passed";
            } else {
                status = "failed";
            }
        }

        return status;
    };

    /**
    * Gibt die Position der Aufgabe zurück
    * @param {object} exercise - Aufgabe
    * @memberOf v3sWbtPlayerApp:model.service_v3sTestSection
    */
    v3sTestSection.prototype.getExerciseSequenceNumber = function (exercise) {
        for (var i = 0; i < this.selectedExercises.length; i++) {
            if (exercise == this.selectedExercises[i]) {
                return i + 1;
            }
        }

        return -1;
    };

    v3sTestSection.prototype.getFirstChild = function () {
        var firstChild = null;

        for (var i = 0; i < this.children.length; i++) {
            if (this.children[i].isSelected()) {
                firstChild = this.children[i];
                break;
            }
        }

        if (!!firstChild && !!firstChild.getFirstChild) {
            firstChild = firstChild.getFirstChild();
        }

        return firstChild;
    };

    v3sTestSection.prototype.getLastChild = function () {
        var lastChild = null;

        for (var i = this.children.length - 1; i >= 0; i--) {
            if (this.children[i].isSelected()) {
                lastChild = this.children[i];
                break;
            }
        }

        if (!!lastChild && !!lastChild.getLastChild) {
            lastChild = lastChild.getLastChild();
        }

        return lastChild;
    };

    v3sTestSection.prototype.getNextChild = function (item) {
        var nextChild = null;

        var afterItem = false;
        for (var i = 0; i < this.children.length - 1; i++) {
            if (this.children[i] === item) {
                afterItem = true;
            }
            if (afterItem && this.children[i + 1].isSelected()) {
                nextChild = this.children[i + 1];
                break;
            }
        }

        if (!nextChild && !!this.parent) {
            nextChild = this.parent.getNextChild(this);
        }

        if (!!nextChild && !!nextChild.getFirstChild) {
            nextChild = nextChild.getFirstChild();
        }

        return nextChild;
    };

    v3sTestSection.prototype.getPreviousChild = function (item) {
        var previousChild = null;

        var beforeItem = false;
        for (var i = this.children.length - 1; i > 0; i--) {
            if (this.children[i] === item) {
                beforeItem = true;
            }
            if (beforeItem && this.children[i - 1].isSelected()) {
                previousChild = this.children[i - 1];
                break;
            }
        }

        if (!previousChild && !!this.parent) {
            previousChild = this.parent.getPreviousChild(this);
        }

        if (!!previousChild && !!previousChild.getLastChild) {
            previousChild = previousChild.getLastChild();
        }

        return previousChild;
    };

    v3sTestSection.prototype.getSectionsCatalog = function () {
        return this.sectionCatalog;
    };

    v3sTestSection.prototype.getItemsByType = function (type) {
        //soll für Test nicht verfügbar sein
        return [];
    };

    v3sTestSection.prototype.changeProperties = function () {
       //deaktivieren
    };

    v3sTestSection.prototype.getGlobalScormData = function (data) {
        for (var i = 0; i < this.children.length; i++) {
            var child = this.children[i];
            if (!!child) {
                child.getGlobalScormData(data);
            }
        }
    };

    v3sTestSection.prototype.setGlobalScormData = function (data) {
        if (!!data) {
            angular.forEach(this.children, function (child) {
                child.setGlobalScormData(data);
            });
        }
    };

    return v3sTestSection;
}]);
